import React, { useEffect, useState, useRef } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "./../../../components/card/card.jsx";
import { asset, machineProfile } from "../../../api/index.js";
import { toast } from "react-toastify";
import { useAuth } from "../../../contexts/AuthContext.jsx";
import { useDashboardContext } from "../../../contexts/NewDashboardContext.jsx";
import { useNavigate, useRoutes } from "react-router-dom";
import {
  formatDateOnly,
  generateLocationToArray,
  Loader,
} from "../../../utils/helper";
import DataTable from "react-data-table-component";
import { LocationFilter } from "../../../components/LocationFilter/index.jsx";
import { matar } from "../../../api/index.js";
import { assetData } from "../data-sample";

function MachineList() {
  const [datas, setDatas] = useState([]);
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState({ company: true });
  const { config } = useAuth();
  const machineTypes = [
    {
      id: "555b1dc5-6983-4501-afdf-474665a3e131",
      name: "Compressor",
    },
    {
      id: "ApronDrive",
      name: "Apron Drive",
    },
    {
      id: "Transformer",
      name: "Transformer",
    },
  ];
  const [deleteRow, setDeleteRow] = useState(null);
  const [changeStatus, setChangeStatus] = useState(null);
  const { updateMachineProfile } = useAuth();
  const canUpdate = updateMachineProfile();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);

  async function getData(forcePage) {
    try {
      setLoading(true);
      const queryParam = {
        ...query,
        page: forcePage ? forcePage : page,
      };
      const res = await machineProfile.list(queryParam);
      if (res.ok) {
        const body = await res.json();
        let data = body.data?.results;
        const totalPage = body.data?.totalPage;
        setTotalPage(totalPage);
        if (data) {
          data.forEach((d) => {
            const locationNameArr = [];
            generateLocationToArray(d.location, locationNameArr);
            d.location_arr = locationNameArr.reverse();
          });
          setDatas(data);
        }
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      toast.error(e.message);
      console.error(e);
    }
  }
  useEffect(() => {
    getData();
    getDataGroup();
  }, [page]);
  useEffect(() => {
    setPage(1);
    getData(1);
  }, [query]);

  const columns = [
    {
      name: <div>Asset ID</div>,
      selector: (row) => row["id"],
      style: { whiteSpace: "unset" },
      minWidth: "200px",
      wrap: true,
      maxWidth: "200px",
    },
    {
      name: "Asset Name",
      selector: (row) => row["machine_name"],
      style: { whiteSpace: "unset" },
      minWidth: "300px",
      wrap: true,
      maxWidth: "300px",
    },
    {
      name: "Asset Category",
      selector: (row) => row["machine_model_no"],
      style: { whiteSpace: "unset" },
      wrap: true,
      minWidth: "200px",
      maxWidth: "200px",
    },

    {
      name: "Criticality",
      selector: (row) => row["context"],
      style: { whiteSpace: "unset" },
      wrap: true,
      minWidth: "150px",
      maxWidth: "150px",
    },
    {
      name: <div>Replacement Year Based on RUL</div>,
      selector: (row) => row["Forecasted Replacement Date"],
      minWidth: "170px",
      maxWidth: "170px",
      cell: (row) => row?.MachineStrategies[0]?.replacement_year,
    },
    {
      name: <div>CAPEX</div>,
      selector: (row) => row["maintenance"],
      minWidth: "150px",
      maxWidth: "150px",
      cell: (row) => row?.MachineStrategies[0]?.default_capex,
    },
  ];
  const ExpandedComponent = ({ data }) => {
    return (
      <div style={{ padding: "10px" }}>
        <Card className="border-theme">
          <CardBody>
            <div className={"row"}>
              <div className="col-md-9">
                <div>
                  Asset ID : <b>{data["id"]}</b>
                </div>
                <div>
                  Asset Name : <b>{data["machine_name"]}</b>
                </div>
                <div>
                  Asset Category : <b>{data["machine_model_no"]}</b>
                </div>
                <div>
                  Replacement Year :{" "}
                  <b>{data?.MachineStrategies[0]?.replacement_year}</b>
                </div>
                <hr />
                <button
                  style={{ marginRight: "10px" }}
                  onClick={() =>
                    navigate("/machine-asset/investment-detail/" + data["id"])
                  }
                  type="button"
                  className="btn btn-outline-theme"
                >
                  <i class="fa fa-chart-area"></i> Investment Profile
                </button>
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
    );
  };

  const handlePageChange = (page) => {
    setPage(page);
  };
  async function getDataGroup() {
    try {
      setLoading(true);
      const res = await matar.getGroupMatar();
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        setGroups(data);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      toast.error(e.message);
      console.error(e);
    }
  }

  const handleChangeLocationFilter = (location_id) => {
    setQuery((prev) => ({
      ...prev,
      location_id: location_id ? location_id : "",
    }));
  };

  const handleChangeMachineType = (machine_type_id) => {
    setQuery((prev) => ({
      ...prev,
      machine_type_id: machine_type_id,
    }));
  };

  const handleChangeMachineGroup = (machine_group_id) => {
    setQuery((prev) => ({
      ...prev,
      machine_group_id: machine_group_id,
    }));
  };

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-xl-12">
          <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">Asset</a>
            </li>
            <li className="breadcrumb-item active">Asset List</li>
          </ul>

          <hr className="mb-4" />

          <div id="datatable" className="mb-5">
            <div className="row mb-2 justify-content-sm-end">
              <div className="col-sm-2 mb-2 mb-sm-0">
                {/*<input*/}
                {/*  style={{ padding: "5px", borderRadius: "4px" }}*/}
                {/*  placeholder={"Search..."}*/}
                {/*  className="border border-theme w-100 bg-transparent text-theme"*/}
                {/*/>*/}
              </div>
              <div className="col-sm-4 mb-2 mb-sm-0">
                <LocationFilter onChange={handleChangeLocationFilter} />
              </div>
              <div className="col-sm-3 mb-2 mb-sm-0">
                <select
                  className="form-select btn btn-sm btn-outline-theme"
                  defaultValue=""
                  onChange={(e) => {
                    handleChangeMachineType(e.target.value);
                  }}
                >
                  <option value="">- Asset Category -</option>
                  {machineTypes.map((mt) => (
                    <option key={mt.id} value={mt.id}>
                      {mt.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-sm-3 mb-2 mb-sm-0">
                <select
                  className="form-select btn btn-sm btn-outline-theme"
                  defaultValue=""
                  onChange={(e) => {
                    handleChangeMachineGroup(e.target.value);
                  }}
                >
                  <option value="">- Asset Group -</option>
                  {groups.map((mt) => (
                    <option key={mt.id} value={mt.id}>
                      {mt.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <Card>
                  <CardBody>
                    <Loader loading={loading}>
                      <DataTable
                        paginationPerPage={20}
                        highlightOnHover
                        expandableRows
                        expandableRowsComponent={ExpandedComponent}
                        theme="dark"
                        columns={columns}
                        data={datas}
                        pagination
                        paginationServer
                        paginationTotalRows={totalPage * 20}
                        onChangePage={handlePageChange}
                      />
                    </Loader>
                  </CardBody>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MachineList;
